import { asyncRoutes } from "@/router/asyncRoutes";

const routes = {
  state: {
    routes: []
  },
  mutations: {
    SET_ROUTES(state, payload) {
      state.routes = payload;
    }
  },
  actions: {
    setRoutes({ commit }, payload) {
      commit("SET_ROUTES", payload);
    }
  },
  getters: {
    getRoutes(state, root) {
      const allowedPermissions = asyncRoutes.filter((route) => {
        if (route.meta && route.meta.permissions) {
          if (root.getPermissions.includes(route.meta.permissions)) {
            return route.item && route.item.title;
          }
        }
      });

      return allowedPermissions;
    }
  }
};

export default routes;
